import { getReferralCode } from "@/api/api";
import { useRequest } from "ahooks";
import React, { useState } from "react";

const useInviteFriends = () => {
  const [inviteCode, setInviteCode] = useState("");
  const { run: fetchInviteCode, loading: inviteCodeLoading } = useRequest(
    getReferralCode,
    {
      manual: true,
      onSuccess(data: any) {
        setInviteCode(data);
      },
      onError(error: any) {},
    }
  );

  return { fetchInviteCode, inviteCodeLoading, inviteCode };
};

export default useInviteFriends;
